<template>
    <div class="tile is-parent is-12">
        <article class="tile is-child box">
        <p class="title">{{ $t('message.companies.add.header') }}</p>
        <b-field :label="$t('message.register-company.add.company.name')">
            <b-input v-model="newCompany.name"></b-input>
        </b-field>
        <b-field :class="vatFieldClass" :label="$t('message.register-company.add.company.business-id')">
            <b-input  v-model="newCompany.vat" @blur="validateVat"></b-input>
        </b-field>
        <b-field label="Palautusprosentti">
            <b-input type="number" v-model="newCompany.return_percent"></b-input>
        </b-field>
        <b-field label="Kieli">
            <b-select v-model="newCompany.lang" placeholder="Valitse kieli">
                <option value="fi">SUOMI</option>
                <option value="en">ENGLANTI</option>
            </b-select>
        </b-field>
        <b-button
        :disabled="isDisabled"
        label="Lisää yritys"
        type="is-primary"
        v-on:click="register" />
        </article>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {
            vatCheck: false,
            newCompany: {
                lang: "fi",
                name: "",
                vat: "",
                return_percent: 0
            },
        }
    },
    computed: {
        isDisabled() {
            if(!this.vatCheck) {
                return "disabled";
            }
            return false;
        },
        vatFieldClass() {
            if(!this.vatCheck) {
                return "is-danger";
            }
            return "";
        }
    },
    methods: {
        validateVat() {
            axios.post('companies/validate-vat', this.newCompany).then((response) => {
                if(response.data.success) {
                    this.vatCheck = true;
                }
                else {
                    this.vatCheck = false;
                    this.toastFailure(this.$t('Y-tunnus on jo käytössä toisella yrityksellä!'));
                }
            })
        },
        register() {
            if (this.newCompany.name == "") {
                this.toastFailure(this.$t('message.error.company.name'))
                return
            } 
            if (this.newCompany.vat == "" && this.vatCheck) {
                this.toastFailure(this.$t('message.error.company.vat'))
                return
            }
            axios.post('/companies', this.newCompany).then((response) => {
                if(response.data.success) {
                    this.toastSuccess("Yritys luotu onnistuneesti!");
                    this.$emit('companyCreated',response.data.uuid);
                }
                else {
                    this.toastFailure("Yrityksen luonti epäonnistui!");
                }
            })
             
        }
    }
}
</script>